export const PREDEFINED_CERTIFICATIONS = [
  "CBI",
  "CAPS Check",
  "QMAP Verification",
  "Infection Training",
  "Dementia Training",
  "Food Safety",
  "TB-Test",
  "X-RAY",
  "QMAP",
  "FIRST AID / CPR",
  "Bloodborne pathogens",
  "Liquid Meds",
  "Hyper/Hypo Glycemia",
  "Transfer Training",
  "Diebetic Training",
  "Hospice Training",
  "Medication Training",
  "Infection Training2",
  "Dementia Training2",
  "Food Safety2",
  "TB Test",
  "X-RAY DUE",
  "QMAP",
  "FIRST AID",
  "Bloodborne Pathogens",
  "Liquid Meds2",
  "Hyoo/Hyper",
  "Transfer",
  "Diebetic",
  "Hospice",
  "Medication"
];

export type PredefinedCertification = typeof PREDEFINED_CERTIFICATIONS[number];